import styled, { css } from 'styled-components';
import Textarea from 'react-textarea-autosize';
import { Field } from 'formik';

export const SubTitle = styled.label<{ truncated?: boolean; isVerMas?: any }>`
	color: #555353;
	font-size: 14px;
	font-family: 'Poppins';

	${({ truncated, isVerMas }) =>
		!truncated &&
		isVerMas &&
		css`
			overflow: hidden;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 3;
		`};
`;

export const UrlName = styled.a`
	color: #35ad71;
	font-weight: bold;
	overflow-wrap: break-word;
`;

export const StyledInput = styled.input<{
	isTouched: boolean;
	isSaved: boolean;
	isDirty: boolean;
	borderRadius?: number;
}>`
	background: ${({ disabled }) => (disabled ? '#FDF1E8' : '#eef4fd')};
	border: ${({ disabled }) => (disabled ? '1px solid #EDAF93' : '1px solid #bbcce7')};
	opacity: 1;
	height: 35px;
	width: 100%;
	border-radius: ${({ borderRadius }) => borderRadius || 20}px;
	padding: 10px;
	font-size: 12px;
	font-family: 'Poppins';
	color: #7899cd;

	:focus {
		color: #013e9e;
		border: 1px solid #799acb;
		background: white;
	}

	${({ isTouched, isSaved, isDirty }) =>
		isDirty &&
		css`
			color: #013e9e;
			border: ${() => (isSaved ? '1px solid #35AD71' : '1px solid #799acb')};
			background: ${() => (isDirty || isSaved ? '#fff' : '#eef4fd')};
		`}
`;

export const StyledTextArea = styled(Textarea)<{
	isTouched: boolean;
	isSaved: boolean;
	disabled?: boolean;
	isDirty: boolean;
	borderRadius?: number;
	commentPadding?: boolean;
	scroll?: boolean;
	editingComment?: boolean;
}>`
	background: ${({ disabled, editingComment }) => (disabled ? '#FDF1E8' : editingComment ? '#fff' : '#eef4fd')};
	border: ${({ disabled, editingComment }) =>
		disabled ? '1px solid #EDAF93' : editingComment ? '' : '1px solid #bbcce7'};
	opacity: 1;
	height: 63px;
	width: 100%;
	border-radius: ${({ borderRadius, commentPadding }) =>
		commentPadding ? '0 15px 15px 15px' : `${borderRadius || 15}px`};
	padding: ${({ commentPadding }) => (commentPadding ? '8px' : '10px')};
	font-size: ${({ commentPadding }) => (commentPadding ? '14px' : '12px')};
	overflow: ${({ scroll }) => (scroll ? '' : 'hidden')};
	font-family: ${({ commentPadding }) => (commentPadding ? 'QuickSand' : 'Poppins')};
	padding-right: ${({ commentPadding }) => (commentPadding ? '80px' : '')};
	color: ${({ disabled }) => (disabled ? '#E68254' : '#7899cd')};
	margin-bottom: ${({ commentPadding }) => (commentPadding ? '-6px' : '')};

	:focus {
		outline: ${({ commentPadding, editingComment }) => (commentPadding || editingComment ? 'none' : '')};
		color: #013e9e;
		border: ${({ editingComment }) => (editingComment ? 'none' : '1px solid #799acb')};
		background: white;
	}

	${({ isTouched, isSaved, isDirty }) =>
		isDirty &&
		css`
			color: #013e9e;
			border: ${() => (isSaved ? '1px solid #35AD71' : '1px solid #799acb')};
			background: ${() => (isDirty || isSaved ? '#fff' : '#eef4fd')};
		`}
`;

export const StyledField = styled(Field)<{ width?: number }>`
	font-size: 12px;
	font-family: Poppins;
	color: #013e9e;
	opacity: 1;
	background: #fff;
	border: 1px solid #bbcce7;
	border-radius: 10px;
	opacity: 1;
	padding: 10px;
	margin: 0px 10px 0px 10px;
	width: ${({ width }) => width || ''}px;
`;

export const GuardarText = styled.p`
	color: #9fd8bd;
	font-size: 13px;
`;

export const VerEjemploButton = styled.button`
	color: #999999;
	font-size: 12px;
	font-family: 'Poppins';
	text-decoration: underline;
`;

export const VerMas = styled.button`
	color: #013e9e;
	font-size: 12px;
	font-family: 'Poppins';
`;

export const EjemploContainer = styled.div`
	border: 1px solid #bbcce7;
	border-radius: 10px;
	opacity: 1;
	padding: 10px;
`;

export const StyledTextAreaRubrica = styled(Textarea)<{
	isSaved: boolean;
	isDisabled?: boolean;
	isDirty: boolean;
	borderRadius?: number;
	commentPadding?: boolean;
	scroll?: boolean;
	firstRowColumn?: boolean;
}>`
	background: ${({ isDisabled }) => (isDisabled ? '#FDF1E8' : '#eef4fd')};
	border: ${({ isDisabled, firstRowColumn }) =>
		firstRowColumn ? '1px solid #013e9e' : isDisabled ? '1px solid #EDAF93' : '1px solid #bbcce7'};
	opacity: 1;
	height: 63px;
	width: 100%;
	border-radius: ${({ borderRadius }) => borderRadius || 15}px;
	padding: 10px;
	font-size: 12px;
	overflow: ${({ scroll }) => (scroll ? '' : 'hidden')};
	font-family: 'Poppins';
	padding-right: ${({ commentPadding }) => (commentPadding ? '70px' : '')};
	color: ${({ isDisabled }) => (isDisabled ? '#E68254' : '#7899cd')};

	font-weight: ${({ firstRowColumn }) => (firstRowColumn ? '900' : 'normal')};

	:focus {
		color: #013e9e;
		border: 1px solid #799acb;
		background: white;
	}

	${({ isSaved, isDirty, isDisabled, firstRowColumn }) =>
		isDirty &&
		!isDisabled &&
		css`
			color: #013e9e;
			border: ${() => (isSaved ? '1px solid #35AD71' : '1px solid #799acb')};
			background: ${() => (isDirty || isSaved ? '#fff' : '#eef4fd')};
		`}
`;

export const StyledTitleBlock = styled.div`
	border-radius: 0px 0px 10px 10px;
	border: 15px solid #faeefc;
	background: #faeefc;
	background-color: #faeefc;
	.inputCell {
		background: #fff;
		background-color: #fff;
		border-radius: 20px;
	}
	margin-bottom: 20px;
`;

export const StyledBlockName = styled.div`
	font-family: Poppins;
	font-size: 14px;
	color: #555353;
	max-width: 400px;
	background: #faeefc;
	display: inline-block;
	padding: 10px 10px 0px 10px;
	border-radius: 10px 10px 0px 0px;
	font-weight: bold;
`;
